import React from 'react';
import withStyles from '@mui/styles/withStyles';
import { Tabs } from '@mui/material';

export default withStyles({})(({ children, ...props }) => {
    return (
        <Tabs
            className="tabs"
            variant="scrollable"
            TabIndicatorProps={{ component: 'indicator' }}
            scrollButtons
            allowScrollButtonsMobile
            {...props}
        >
            {children}
        </Tabs>);
});